import React from 'react';
import classes from './services.module.css';
import { useNavigate } from 'react-router-dom';
import Title from '../../containers/title/title';
import Path from '../../../assets/images/white-path.png';
import PitchBooking from '../../../assets/images/pitch-booking.png';
import Summer from '../../../assets/images/summer.png';
import SummerCamp from '../../../assets/images/summer-camp.png';
import Winter from '../../../assets/images/winter.png';
import WinterCamp from '../../../assets/images/winter-camp.png';
import Football from '../../../assets/images/camp.png';
import FootballCamp from '../../../assets/images/football-camp.png';
import TeamBuilding from '../../../assets/images/team-building.png';
import Team from '../../../assets/images/team.png';
import Birthday from '../../../assets/images/birthday.png';
import BirthdayParties from '../../../assets/images/birthday-parties.png';
import { getImageUrl } from '../../../utils/imageUrl';

const Services = (props) => {
    const navigate = useNavigate();
    // const list = [PitchBooking, SummerCamp, WinterCamp, FootballCamp, Team, BirthdayParties];
    // const activityIcons = [path, summer, winter, football, teamBuilding, birthday]
    let list = [
        {
            'name': 'PITCH BOOKING',
            'name_ar': 'حجز الملعب',
            'src': Path,
            'background': PitchBooking,
            'link': '/field-booking'
        },
        {
            'name': 'SUMMER CAMP',
            'name_ar': 'المخيم الصيفي',
            'src': Summer,
            'background': SummerCamp,
            'link': '/camps/summer-camp'
        },
        {
            'name': 'WINTER CAMP',
            'name_ar': 'المخيم الشتوي',
            'src': Winter,
            'background': WinterCamp,
            'link': '/camps/winter-camp'
        },
        {
            'name': 'FOOTBALL CAMP',
            'name_ar': 'مخيم كرة القدم',
            'src': Football,
            'background': FootballCamp,
            'link': '/camps/football-camp'
        },
        {
            'name': 'TEAM BUILDING',
            'name_ar': 'بناء الفريق',
            'src': TeamBuilding,
            'background': Team,
            'link': '/activities/team-building'
        },
        {
            'name': 'BIRTHDAY PARTIES',
            'name_ar': 'حفلات أعياد الميلاد',
            'src': Birthday,
            'background': BirthdayParties,
            'link': '/activities/birthdays'
        }
    ]
    const clickedHandler = (link) => {
        if (!props.isAuthenticated) props.setShowLoginForm(true)
        else navigate(link)
    }
    return (
        <div className={classes.Services}>
            <Title title={props.serviceSection?.title} />
            {/* <ul className={classes.ServicesList}>{props.featuredActivities?.map((activity, i) =>
                i < 6 && <NavLink to={activity.type?.slug} key={activity.id}>
                    <div className={classes.DarkEffect} />
                    <li style={{ backgroundImage: `url(${list[i]})` }}>
                        <img src={activityIcons[i]} alt={activity.type?.name} />
                        <span>{activity.type?.name} <span className={classes.Arrow} /></span>
                    </li>
                </NavLink>
            )}</ul> */}
            <ul className={classes.ServicesList}>
                {list?.map((activity, i) => (
                    <a 
                        key={i}
                        href={i > 0 ? activity.link : undefined}
                        onClick={() => i === 0 && clickedHandler(activity.link)}
                    >
                        <div className={classes.DarkEffect} />
                        <li style={{ backgroundImage: `url(${getImageUrl(activity.background)})` }}>
                            <img src={activity.src} alt={activity.name} />
                            <span>
                                {parseInt(localStorage.getItem('language')) === 1 ? activity.name : activity.name_ar} 
                                <span className={classes.Arrow} />
                            </span>
                        </li>
                    </a>
                ))}
            </ul>
        </div>
    )
}
export default Services;